/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is governed by the Apache 2.0 license. */

import React, { FC, useMemo } from 'react';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { formatISO, isValid } from 'date-fns';
import { IEntityFieldProps } from "icerockdev-admin-toolkit";
import { InputLabel } from "@material-ui/core";
import styles from './styles';
import { makeStyles } from "@material-ui/core/styles";

type IProps = IEntityFieldProps & {};

const useStyles = makeStyles(styles)

const OrderDateReadonly: FC<IProps> = ({
  value,
  label,
  onClick,
}: IProps) => {
  const classes = useStyles();

  const parsedValue = useMemo(() => {
    const date = parseISO(value);

    return (date && isValid(date) && formatISO(date)) || '';
  }, [value]);

  return (
    <div onClick={onClick} className={classes.label}>
      <InputLabel>{label}</InputLabel>
      {parsedValue ? (
        format(parseISO(parsedValue), 'dd.MM.yyyy')
      ) : (
        <div>&nbsp;</div>
      )}
    </div>
  )
};


export { OrderDateReadonly };
